import type { MiniAppValues } from "@rakazo/contracts";

/** No auth tokens or resource ids enter the app. Its parent pins the storage target. */
export function miniAppSdk(token: string, values: MiniAppValues): string {
  const literal = (value: unknown) =>
    JSON.stringify(value)
      .replace(/</g, "\\u003c")
      .replace(/\u2028/g, "\\u2028")
      .replace(/\u2029/g, "\\u2029");
  return `<script>(() => {
const token=${literal(token)}, values=new Map(Object.entries(${literal(values)})), waits=new Map();
let queued=false, outstanding=Promise.resolve();
function send(){
  if(queued) return outstanding;
  queued=true;
  outstanding=new Promise((resolve,reject)=>queueMicrotask(()=>{
    queued=false; const id=crypto.randomUUID(); waits.set(id,{resolve,reject});
    parent.postMessage({type:'wurkees-app-save',token,id,values:Object.fromEntries(values)},'*');
  }));
  outstanding.catch(()=>{}); return outstanding;
}
addEventListener('message',e=>{
  if(e.source!==parent||e.data?.type!=='wurkees-app-result'||e.data.token!==token) return;
  const wait=waits.get(e.data.id); if(!wait)return; waits.delete(e.data.id);
  e.data.ok?wait.resolve():wait.reject(new Error(e.data.error||'App data could not be saved.'));
});
function key(k){k=String(k);if(k.length>128||['__proto__','prototype','constructor'].includes(k))throw new Error('Invalid app storage key.');return k;}
function put(k,v){k=key(k);v=String(v);const next=new Map(values);next.set(k,v);
  if(next.size>256||new TextEncoder().encode(JSON.stringify(Object.fromEntries(next))).length>524288)throw new DOMException('App storage is limited to 512 KB.','QuotaExceededError');
  values.set(k,v);return send();}
const storage={getItem:k=>values.get(String(k))??null,setItem:(k,v)=>{put(k,v);},removeItem:k=>{values.delete(String(k));send();},clear:()=>{values.clear();send();},key:i=>Array.from(values.keys())[i]??null};
Object.defineProperty(storage,'length',{get:()=>values.size,configurable:true});
const proxy=new Proxy(storage,{get:(o,k)=>Reflect.has(o,k)?Reflect.get(o,k):values.get(String(k)),set:(o,k,v)=>{put(k,v);return true;},deleteProperty:(o,k)=>{storage.removeItem(k);return true;},ownKeys:()=>Array.from(values.keys()),getOwnPropertyDescriptor:(o,k)=>values.has(String(k))?{enumerable:true,configurable:true,value:values.get(String(k))}:Reflect.getOwnPropertyDescriptor(o,k)});
Object.defineProperty(window,'localStorage',{value:proxy});
Object.defineProperty(window,'wurkees',{value:Object.freeze({storage:Object.freeze({
  get:k=>{const v=storage.getItem(k);return v===null?null:JSON.parse(v);},
  set:(k,v)=>{const text=JSON.stringify(v);if(text===undefined)throw new Error('Use a JSON value.');return put(k,text);},
  remove:k=>{values.delete(String(k));return send();},clear:()=>{values.clear();return send();},flush:()=>outstanding
})})});
})();</script>`;
}
